var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"phone-number"},[_vm._v(" "+_vm._s(_vm.internationalCode)+_vm._s(_vm.areaCode)+_vm._s(_vm.phoneNumber)+" "),_c('a',{attrs:{"href":("tel:" + _vm.phone)}},[_c('font-awesome-icon',{attrs:{"icon":"phone"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }